/** Shared relative-time wording (Fleets, Replay, the live map's last-seen label). */

/** How long ago, the way a person says it: "just now", "4 min", "3 h", "yesterday", "14 days", "3 months". */
export function sinceText(ms: number): string {
  const s = Math.max(0, ms / 1000);
  if (s < 45) return 'just now';
  if (s < 3600) return `${Math.max(1, Math.round(s / 60))} min ago`;
  const h = s / 3600;
  if (h < 24) return `${Math.floor(h)} h ago`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'yesterday';
  if (d < 60) return `${d} days ago`;
  return `${Math.round(d / 30)} months ago`;
}
